import { useState } from "react";

import VertragBlatt from "./VertragBlatt";
import "../styles/vertragstext.css";

/**
 * Ein Vertragsblatt so, wie es gedruckt wird — oder als reiner Text.
 *
 * Benjamin, 26.10.2026: „beim Anschauen der Vorschau der Vertragsurkunde gibt
 * es keine Fußzeile und kein Briefpapier." Die Textansicht (`VertragBlatt`)
 * kann beides nicht zeigen: die Fußzeile ist ein Seitenrand-Element, das nur
 * der PDF-Renderer setzt. Der Server schickt deshalb die Seiten des echten PDF
 * als Bilder mit (`vertrag_seitenbilder.py`); sie sind die Voreinstellung.
 * Die Textansicht bleibt als Umschalter — zum Lesen am Telefon und als
 * Rückfall, wenn das Rendern einmal scheitert.
 */
export default function VertragAnsicht({ css, html, bilder }: {
  css: string; html: string; bilder?: string[];
}) {
  const [nurText, setNurText] = useState(false);
  const hatBilder = !!bilder && bilder.length > 0;

  return (
    <>
      {hatBilder && (
        <div className="vt-ansicht-wahl" role="group" aria-label="Ansicht">
          <button type="button" className={nurText ? "" : "is-on"} aria-pressed={!nurText}
                  onClick={() => setNurText(false)}>Wie gedruckt</button>
          <button type="button" className={nurText ? "is-on" : ""} aria-pressed={nurText}
                  onClick={() => setNurText(true)}>Nur Text</button>
        </div>
      )}
      {hatBilder && !nurText ? (
        <div className="vt-seiten">
          {bilder!.map((src, i) => (
            <figure key={i} className="vt-seite">
              <img src={src} alt={`Seite ${i + 1} von ${bilder!.length}`} loading="lazy" />
              <figcaption>Seite {i + 1} von {bilder!.length}</figcaption>
            </figure>
          ))}
        </div>
      ) : (
        <VertragBlatt css={css} html={html} />
      )}
    </>
  );
}
